export class Password {
    constructor(
        public passOld?: string,
        public newPass?: string
    ){}
}